import { render, staticRenderFns } from "./POptionBar.vue?vue&type=template&id=378ea4b5&scoped=true"
import script from "./POptionBar.vue?vue&type=script&lang=ts"
export * from "./POptionBar.vue?vue&type=script&lang=ts"
import style0 from "./POptionBar.vue?vue&type=style&index=0&id=378ea4b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378ea4b5",
  null
  
)

export default component.exports